import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {cdnResize} from '../services/utils';
import ReviewStars from './Review-stars';
import PricingAppBox from './Pricing-app-box';
import AddToSiteButton from './Add-to-site-button';
import {openAppInModal, addAppClientData, openEditorApp} from '../services/app-flow';
import {FormattedMessage} from 'react-intl';
import {isAppNew, isOpenInEditorVisible} from '../services/app-type-detector';
import {getIfAppIsInstalledPromise} from '../services/wrapped-app-market-sdk';
import {execBI} from '../services/bi-events-manager';
import injectMain from '../services/inject-main';
import {isExperiment} from '../config';
import ALink from './ALink';

const handleOpenInEditor = (app, biPosition = 0) => {
  return ev => {
    ev.preventDefault();
    openEditorApp(app, biPosition);
  };
};

const renderStatus = isInstalled => {
  if (isInstalled) {
    return (
      <div className="application-status-circle typography_t3_1">
        <span className="application-status-installed-ico"></span>
        <div className="application-status-installed"><FormattedMessage id="application.status.installed"/></div>
      </div>
    );
  }
};

const getIsPremiumPending = (app, pendingAppData) => {
  if (app.isInstalled && app.myAppData && app.myAppData.clientSpec.appDefinitionId && app.myAppData.clientSpec.vendorProductId) {
    return true;
  }

  return pendingAppData && pendingAppData.reasons.indexOf('Premium') !== -1;
};

class AppBoxCollection extends React.Component {

  constructor(props) {
    super(props);
    this.handleOpenApp = this.handleOpenApp.bind(this);
  }

  handleOpenApp(app, biPosition = 0) {
    return ev => {
      if (!isExperiment('specs.market.AppPageInsideMarket', this.props.experiments) && this.props.market !== 'standalone') {
        ev.preventDefault();
        openAppInModal(app.slug);
      }
      execBI('APP_MODAL_OPEN_CLICK', {app, biPosition});
    };
  }

  componentDidMount() {
    getIfAppIsInstalledPromise({appDefinitionId: this.props.app.appDefinitionId, includingDemoMode: true})
      .then(isInstalled => this.setState({app: addAppClientData(this.props.app, isInstalled), loaded: true}))
      .catch(() => this.setState({app: addAppClientData(this.props.app, false), loaded: true}));
  }

  render() {
    const state = this.state || {};
    const app = state.app || this.props.app;
    const reviews = this.props.reviews[app.appDefinitionId];
    const isOpenAppLinkVisible = isOpenInEditorVisible(app);
    const isPremiumPending = getIsPremiumPending(app, this.props.pendingAppData);
    const downloadsAllTime = app.downloadsAllTime || 0;

    return (
      <div className={classNames('application-box-collections', {'collections-app-installed': app.isInstalled, 'collections-app-main': this.props.isMain, 'app-box-loading': !state.loaded})}>
        <ALink className="app-link" to={`/${app.slug}/overview`} onClick={this.handleOpenApp(app, this.props.biPosition)}>

          {renderStatus(app.isInstalled)}

          <img
            className="application-advert"
            width="60"
            height="60"
            src={cdnResize(app.roundIcon || app.appIcon, 60, 60)}
            alt={`${app.name} by ${app.by} || WIX App Market`}
            />

          <h3 className={classNames('application-title typography_h2', {'has-mobile': app.hasMobile})}>{app.name}</h3>

          <div className="spacer-line"></div>

          <p className="application-description application-description-limit typography_t1" dangerouslySetInnerHTML={{__html: app.teaser}}></p>

          <PricingAppBox app={app}/>

          {!isAppNew(app) ?
            <div className="stats-app-box stats-app-box-absolute typography_t3_1">
              <ReviewStars reviews={reviews}/>
              <div className="spacer"></div>
              <div className="downloads">{downloadsAllTime.toLocaleString()}</div>
            </div> : ''}

          {isAppNew(app) ? <div className="new"><FormattedMessage id="appStats.new"/></div> : ''}
        </ALink>

        {isOpenAppLinkVisible ?
          <div className="cta">
            <a href="#" onClick={handleOpenInEditor(app, this.props.biPosition)}><FormattedMessage id="application.action.open"/></a>
          </div> : '' }

        <div className="circle-loader circle-loader-smaller"></div>

        <AddToSiteButton app={app} biPosition={this.props.biPosition}/>

        {this.props.onRemovePending && !isPremiumPending ?
          <a title="Delete" className="app-box-remove-pending" href="#" onClick={this.props.onRemovePending(app)}></a> : '' }

      </div>
    );
  }

  static propTypes = {
    app: PropTypes.object.isRequired,
    isMain: PropTypes.bool,
    reviews: PropTypes.object,
    pendingAppData: PropTypes.object,
    onRemovePending: PropTypes.func,
    biPosition: PropTypes.number,
    market: PropTypes.string,
    experiments: PropTypes.object
  }
}

export default injectMain(AppBoxCollection);



// WEBPACK FOOTER //
// ./components/App-box-collection.js